<admin-app-header></admin-app-header>

<div class="container-fluid">
    <div class="row py-3">
        <div class="col-12">
            <h2><i class="fa-solid fa-bug me-2"></i>Known Issues</h2>
            <p class="text-muted">
                Track and investigate known issues across the platform.
            </p>
        </div>
    </div>

    <!-- Filters -->
    <div class="row mb-3">
        <div class="col-md-3">
            <label class="form-label">Status</label>
            <select class="form-select" (change)="onStatusFilterChange($event)" [value]="statusFilter">
                <option value="all">All Statuses</option>
                <option value="investigating">Investigating</option>
                <option value="monitoring">Monitoring</option>
                <option value="resolved">Resolved</option>
                <option value="wont-fix">Won't Fix</option>
            </select>
        </div>
        <div class="col-md-3">
            <label class="form-label">Severity</label>
            <select class="form-select" (change)="onSeverityFilterChange($event)" [value]="severityFilter">
                <option value="all">All Severities</option>
                <option value="critical">Critical</option>
                <option value="high">High</option>
                <option value="medium">Medium</option>
                <option value="low">Low</option>
            </select>
        </div>
        <div class="col-md-3">
            <label class="form-label">Entity Type</label>
            <select class="form-select" (change)="onEntityTypeFilterChange($event)" [value]="entityTypeFilter">
                <option value="all">All Types</option>
                <option value="subscription">Subscription</option>
                <option value="payment">Payment</option>
                <option value="merchant">Merchant</option>
                <option value="client">Client</option>
                <option value="other">Other</option>
            </select>
        </div>
        <div class="col-md-3 d-flex align-items-end">
            <span class="text-muted">
                Showing {{ filteredIssues.length }} of {{ knownIssues.length }} issues
            </span>
        </div>
    </div>

    <!-- Issues List -->
    <div class="row">
        <div class="col-12">
            <div class="card" *ngFor="let issue of filteredIssues">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <div>
                        <span [ngClass]="getSeverityBadgeClass(issue.severity)" class="badge me-2">
                            {{ issue.severity | uppercase }}
                        </span>
                        <span [ngClass]="getStatusBadgeClass(issue.status)" class="badge me-2">
                            {{ issue.status | titlecase }}
                        </span>
                        <i [class]="getEntityTypeIcon(issue.entityType)" class="me-1"></i>
                        <strong>{{ issue.title }}</strong>
                    </div>
                    <div>
                        <a
                            *ngIf="getEntityLink(issue)"
                            [routerLink]="getEntityLink(issue)"
                            class="btn btn-sm btn-outline-primary me-2"
                            title="View in Admin"
                        >
                            <i class="fa-solid fa-external-link-alt"></i> View {{ issue.entityType | titlecase }}
                        </a>
                        <button
                            class="btn btn-sm btn-outline-secondary"
                            (click)="copyToClipboard(issue.entityId)"
                            title="Copy Entity ID"
                        >
                            <i class="fa-solid fa-copy"></i> Copy ID
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <p class="card-text lead">{{ issue.description }}</p>

                    <div class="row mt-3" *ngIf="issue.resolution || issue.rootCause">
                        <div class="col-12">
                            <div class="alert alert-success" *ngIf="issue.resolution">
                                <h6><i class="fa-solid fa-check-circle me-1"></i>Resolution</h6>
                                <p class="mb-0">{{ issue.resolution }}</p>
                            </div>
                            <div class="alert alert-info" *ngIf="issue.rootCause">
                                <h6><i class="fa-solid fa-search me-1"></i>Root Cause</h6>
                                <p class="mb-0">{{ issue.rootCause }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Expand/Collapse Audit Content -->
                    <div class="mt-3">
                        <button 
                            class="btn" 
                            [ngClass]="issue.expanded ? 'btn-secondary' : 'btn-primary'"
                            (click)="toggleExpand(issue)"
                        >
                            <i [class]="issue.expanded ? 'fa-solid fa-chevron-up' : 'fa-solid fa-file-alt'" class="me-2"></i>
                            {{ issue.expanded ? 'Close Audit' : 'View Full Audit' }}
                        </button>
                        <button 
                            *ngIf="issue.expanded"
                            class="btn btn-outline-secondary ms-2"
                            (click)="copyAuditContent(issue)"
                        >
                            <i class="fa-solid fa-copy me-2"></i>
                            Copy Audit Content
                        </button>
                    </div>

                    <!-- Rendered Audit Content -->
                    <div class="audit-content mt-4" *ngIf="issue.expanded">
                        <div class="audit-rendered" [innerHTML]="renderMarkdown(issue.auditContent)"></div>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="filteredIssues.length === 0" class="text-center py-5">
                <i class="fa-solid fa-check-circle fa-3x text-success mb-3"></i>
                <h4>No issues match your filters</h4>
                <p class="text-muted">Try adjusting your filters or check back later.</p>
            </div>
        </div>
    </div>
</div>
